'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _includes = require('lodash/includes');var _includes2 = _interopRequireDefault(_includes);
var _pickBy = require('lodash/pickBy');var _pickBy2 = _interopRequireDefault(_pickBy);
var _keys = require('lodash/keys');var _keys2 = _interopRequireDefault(_keys);
var _values = require('lodash/values');var _values2 = _interopRequireDefault(_values);

var _reduxForm = require('redux-form');
var _reactScroll = require('react-scroll');
var _components = require('../../components');

var _PublishPropertyFormConstants = require('./PublishPropertyFormConstants');
var _publish = require('../../redux/modules/normalizers/publish');var _publish2 = _interopRequireDefault(_publish);

var _PublishPropertyForm = require('./PublishPropertyForm.scss');var styles = _interopRequireWildcard(_PublishPropertyForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// // Styles
var AboutBuildingBlock = function (_Component) {_inherits(AboutBuildingBlock, _Component);function AboutBuildingBlock() {var _temp, _this, _ret;_classCallCheck(this, AboutBuildingBlock);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.





    renderInput = function (_ref) {var input = _ref.input,meta = _ref.meta;return (
        _react2.default.createElement('input', _extends({},
        input, {
          type: 'text',
          placeholder: _this.props.translate('year'),
          className: (0, _classnames2.default)(styles.inputNumb, styles.numeric, 'form-control',
          { not_valid: meta.touched && meta.error && !meta.active }) })));}, _temp), _possibleConstructorReturn(_this, _ret);}AboutBuildingBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref2) {var elevatorsProp = _ref2.elevators,locale = _ref2.locale,config = _ref2.config;var elevatorsChanged = !(0, _isEqual2.default)(this.props.elevators, elevatorsProp);var configChanged = !(0, _isEqual2.default)(this.props.config, config);var localeChanged = this.props.locale !== locale;return elevatorsChanged || localeChanged || configChanged;};AboutBuildingBlock.prototype.


  renderConstructionYear = function renderConstructionYear() {
    return (
      _react2.default.createElement('div', { className: styles.requiredFieldWrapper },
        _react2.default.createElement('span', { className: 'label' }, this.props.translate('constructionYear')),
        _react2.default.createElement('div', { className: 'fieldset' },
          _react2.default.createElement(_reactScroll.Element, { name: 'construction_year' },
            _react2.default.createElement(_reduxForm.Field, {
              name: 'construction_year',
              props: { locale: this.props.locale },
              component: this.renderInput,
              normalize: _publish2.default.construction_year })))));





  };AboutBuildingBlock.prototype.

  renderElevators = function renderElevators() {
    var elevatorValues = (0, _PublishPropertyFormConstants.elevators)(this.props.translate);
    return (
      _react2.default.createElement('div', { className: styles.requiredFieldWrapper },
        _react2.default.createElement('span', { className: 'label' }, this.props.translate('elevator')),
        _react2.default.createElement('div', { className: 'fieldset' },
          _react2.default.createElement(_components.OMSegmentedControl, {
            inReduxForm: true,
            className: 'multiButtons rounded',
            name: 'elevators',
            values: elevatorValues,
            selectedValue: this.props.elevators || elevatorValues[0].value }))));




  };AboutBuildingBlock.prototype.

  renderBuildingCommodities = function renderBuildingCommodities() {
    var options = (0, _PublishPropertyFormConstants.additionsOptions)(this.props.translate);
    var configBuildingCommodities = (0, _pickBy2.default)(this.props.config.buildingCommodities, function (item) {return item;});
    var commoditiesKeys = (0, _keys2.default)(configBuildingCommodities);
    var commodities = options.filter(function (item) {return (0, _includes2.default)(commoditiesKeys, item.id);});
    return !!commodities.length &&
    _react2.default.createElement('div', { className: styles.requiredFieldWrapper },
      _react2.default.createElement('span', { className: (0, _classnames2.default)('label', styles.labelMid) }, this.props.translate('additions')),
      _react2.default.createElement('div', { className: (0, _classnames2.default)('fieldset', styles.commodities) },
        _react2.default.createElement(_reduxForm.Field, {
          name: 'commodities',
          props: { locale: this.props.locale },
          component: function component(_ref3) {var input = _ref3.input;return _react2.default.createElement(_components.OMMultiCheckbox, _extends({ options: commodities }, input));} })));




  };AboutBuildingBlock.prototype.

  render = function render() {var _props =
    this.props,config = _props.config,locale = _props.locale;
    var configStatuses = [
    config.constructionYear,
    config.elevators,
    config.maintenance].concat(
    (0, _values2.default)(config.buildingCommodities));

    var shouldRender = configStatuses.some(function (item) {return !!item;});

    return shouldRender &&
    _react2.default.createElement(_reactScroll.Element, { name: 'aboutBuilding', className: styles.sectionBlock },
      _react2.default.createElement('div', { className: styles.title }, this.props.translate('sections', 'building')),
      config.constructionYear && this.renderConstructionYear(),
      config.elevators && this.renderElevators(),
      config.maintenance && !this.props.isForeign && _react2.default.createElement(_components.OMPriceInput, {
        field: 'payments.maintenance',
        locale: locale,
        placeholder: '' + this.props.translate('maintenance'),
        isMobile: this.props.isMobile }),

      config.buildingCommodities && this.renderBuildingCommodities());


  };return AboutBuildingBlock;}(_react.Component);exports.default = AboutBuildingBlock;


AboutBuildingBlock.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  locale: _propTypes2.default.string,
  config: _propTypes2.default.object.isRequired,
  elevators: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  isForeign: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishForm/AboutBuildingBlock.js
// module id = 2995
// module chunks = 0